<template>
  <div class="w-full h-screen bg-white overflow-x-hidden">
    <Navbar @sidebarDismissed=" (value) => {expand(value)}"  class=" w-full sticky top-0 z-40"/>
    <div>
      <Sidebar class="sidebar"/>
      <div :class="[!expandBody ? 'main px-5 space-y-4 margin' : 'main px-5 space-y-4']">
        <!-- the top route and username grid -->
        <div class="justify-between flex pt-6 text-size-md font-medium text-gray-500 w-full">
          <span><span class=" text-emerald-500">>Home</span> > PR Approval</span>
          <span>{{ firstname }} {{ surname }}</span>
        </div>
          <div>
          <!-- Timeline -->
          <div class=" shadow-md text-gray-400 col-span-full border hover:shadow-lg bg-white">
            <!-- The chart title -->
            <div class="ml-8 flex mt-4 mb-4 space-x-1 items-center">
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m14.414 0h-9.414a3 3 0 0 0 -3 3v21h20v-16.414zm.586 3.414 3.586 3.586h-3.586zm-11 18.586v-19a1 1 0 0 1 1-1h8v7h7v13zm9-8h3v2h-3v3h-2v-3h-3v-2h3v-3h2z"/></svg> -->
              <svg class="h-4 w-4 fill-emerald-500" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="m18,0H6c-1.654,0-3,1.346-3,3v21h18V3c0-1.654-1.346-3-3-3Zm1,22H5V3c0-.552.448-1,1-1h12c.552,0,1,.448,1,1v19ZM7,5h10v2H7v-2Zm0,5h10v2H7v-2Zm0,5h5v2h-5v-2Z"/></svg>
              <p class="text-left text-size-md font-medium text-gray-600">PR Approval</p>
            </div>
            <!-- the prs -->
            <div class="mx-8 mb-5 mt-5 border shadow px-4 pb-8 pt-3 space-y-8">
              <!-- the Prs table -->
              <div v-if="prs.length > 0" class="mt-2 space-y-10">
                <div v-for="(data, i) in prs" :key="i" class="">
                  <!-- pr -->
                  <div class="space-y-1">
                    <!-- the title -->
                    <div class="flex">
                      <span class="text-size-sm font-medium text-left text-gray-500">Purchase Requisition {{ (i+1) }}</span>
                    </div>
                    <!-- the table -->
                    <table  id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                      <thead>
                        <tr class=" bg-emerald-600 text-size-xs" style="">
                          <td class="py-3 px-2 text-left text-white font-bold">Item</td>
                          <td class="py-3 px-2 text-left border-l text-white font-bold">Description</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Budget Line</td>
                          <td class="py-3 px-2 border text-left">{{ data.budgetLine }}</td>
                        </tr>
                         <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Budget Amount</td>
                          <td class="py-3 px-2 border text-left">{{ data.budgetAmount }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">District</td>
                          <td class="py-3 px-2 border text-left">{{ data.districtName.name }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Specific Area/Region</td>
                          <td class="py-3 px-2 border text-left">{{ data.area }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Specification of Goods/Services</td>
                          <td class="py-3 px-2 border text-left">{{ data.specification }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Check In Date</td>
                          <td class="py-3 px-2 border text-left">{{ formatData(data.checkInDate) }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Check Out Date</td>
                          <td class="py-3 px-2 border text-left">{{ formatData(data.checkInDate) }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">No of Single Rooms</td>
                          <td class="py-3 px-2 border text-left">{{ data.singleRooms }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">No of Double Rooms</td>
                          <td class="py-3 px-2 border text-left">{{ data.doubleRooms }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Conference Packages</td>
                          <td class="py-3 px-2 border text-left" v-html="
                            `<ul>
                              ${confPackagesHtml(data)}
                            </ul>`
                          "></td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Quantity Per Participant</td>
                          <td class="py-3 px-2 border text-left">{{ data.Qparticipants }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">No of Participants</td>
                          <td class="py-3 px-2 border text-left">{{ data.noParticipants }}</td>
                        </tr>
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">No of Days Needed</td>
                          <td class="py-3 px-2 border text-left">{{ data.days }}</td>
                        </tr>
                        <!-- <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Delivery Time</td>
                          <td class="py-3 px-2 border text-left">{{ data.deliveryTime }}</td>
                        </tr> -->
                        <tr class=" text-gray-600 text-size-sm" style="">
                          <td class="py-3 px-2 border text-left">Delivery Date</td>
                          <td class="py-3 px-2 border text-left">{{ formatData(data.deliveryDate) }}</td>
                        </tr>
                        
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- no prs available -->
              <div v-else class="py-4">
                <div class="shadow border py-6">
                  <span class="text-size-md font-medium text-gray-400">Purchase Requisition not Available</span>
                </div>
              </div>
               <!-- {{ attachments }} -->
              <div v-if="attachments !== null && Array(attachments) && attachments.length > 0">
                <!-- the title -->
                <div class="flex mt-1">
                  <span class="text-size-sm font-medium text-left text-gray-500">Purchase Requisition Attachments</span>
                </div>
                <table id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                    <thead>
                      <tr class="bg-emerald-600 text-size-xs" style="">
                        <td class="py-3 px-2 text-left text-white font-bold">#</td>
                        <td class="py-3 px-2 border-l text-left text-white font-bold">File Name</td>
                        <td class="py-3 px-2 border-l text-left text-white font-bold">File Size</td>
                        <td class="py-3 px-2 border-l text-center text-white font-bold">Download</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, i) in attachments" :key="i" class=" text-gray-600 text-size-sm" style="">
                        <td class="py-3 px-2 border text-left">{{ (i + 1) }}</td>
                        <td class="py-3 px-2 border text-left">{{ formatData(data.realName) }}</td>
                        <td class="py-3 px-2 border text-left">{{ fileSizeFormatter(data.size) }}</td>
                        <td @click="downloadAttachments(data.realName, data.name)" class="py-3 px-2 border text-left">
                           <svg class="w-5 h-5 mx-auto fill-emerald-600" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                            <path d="m21,9v9h-6.329l-1,1h-3.343l-1-1H3v-9h8v4.034l-1.793-1.792-1.414,1.414,2.881,2.881c.366.365.846.549,1.326.549s.96-.184,1.326-.549l2.881-2.881-1.414-1.414-1.793,1.792v-4.034h8Zm-8-3h-2v3h2v-3Zm4-2h-2v2h2v-2Zm-4-3h-2v2h2V1Zm6-1h-2v2h2V0ZM7,0h-2v2h2V0Zm2,4h-2v2h2v-2Zm-4.5,3L2.083,0H0l2.417,7h2.083Zm17.083,0L24,0h-2.083s-2.417,7-2.417,7h2.083Zm-13.083,13H1v2c0,1.105.895,2,2,2h18c1.105,0,2-.895,2-2v-2h-7.5l-1,1h-5l-1-1Z"/>
                          </svg>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
              <!-- the end -->
            </div>
            <!-- <div class="col-span-full sm:col-span-1">
              <div class="flex-1 mb-10 space-x-0.5">
                <button
                  @click="approval('approved')"
                  class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-600  text-white font-medium leading-tight transform hover:bg-emerald-700 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                  Approve
                </button>
                 <button
                  @click="showDenialModal()"
                  class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-600  text-white font-medium leading-tight transform hover:bg-emerald-700 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                    Deny
                </button>
              </div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- the message modal -->
    <MessageModal
      :isOk="isOk"
      :title="messageTitle"
      :message="message"
      ref="messageModal"
    />
    <!-- the pop up modal -->
    <PopUp 
      ref="popupRef"
      :message="saveMessage" />
    <!-- the warning modal -->
    <WarningModal
      :isOk="isOk"
      @click="(event) => {
        warningHandler(event)
      }"
      :title="'Request Submission Error'"
      :event="'close'"
      :message="'You cannot submit a new request because you have an active request that is still active.'"
      ref="warningModal"
    />
     <!-- the budget percentage modal -->
     <BudgetPercentageModal
      v-if="showPercentageModal"
      :isOk="isOk"
      :title="messageTitle"
      :message="message"
      :budgetSources="selectedBudgetSources"
      ref="budgetPercentageModal"
      @error="(error) => {
        percentageError(error)
      }"
      @success="(percentageData) => {
        savePercentageData(percentageData)
      }"
    />
    <!-- the pr modal -->
    <PRModal ref="prModal" @onSubmit="() => { refreshPRs() }"/>
    <!-- confirm mopdal -->
    <ConfirmModal
      :isOk="isOk"
      :title="'Request Clearance'"
      :message="'Are you sure you want to clear the request?'"
      @confirm="(data) => {
        clearRequest()
      }"
      ref="confirmModal"
    />
    <!-- Loader modal -->
    <LoadingModal
      ref="loadingModal"
    />
    <!-- the signature modal -->
    <SignatureModal
      @base64 = "(data) => {
        submitSignature(data)
      }"
      ref="signatureModal"
    />
    <!-- feedback modal -->
    <FeedbackModal
      :isOk="isOk"
      :title="feedbackTitle"
      ref="feedbackModal"
      @selectedFeedback="(item) => {
        feedback = item
        approval('denied')
      }"
    />
  </div>
</template>

<script>
import Navbar from '@/components/AdminNavbar.vue'
import Sidebar from '@/components/AdminSideBar.vue'
import MessageModal from './MessageModal.vue'
import { mapState } from 'vuex'
import { interval } from 'rxjs'
import PopUp from './PopUp.vue'
import WarningModal from './WarningModal.vue'
import { ajax } from 'rxjs/ajax'
import BudgetPercentageModal from './BudgetPercentageModal.vue'
import PRModal from './PRsModal.vue'
import ConfirmModal from './ConfirmModal.vue'
import SignatureModal from './SignatureModal.vue'
import LoadingModal from './LoadingModal.vue'
import FeedbackModal from './FeedbackModal.vue'

export default {
  computed: {
    ...mapState([
      'id',
      'firstname',
      'surname',
      'memo',
      'token',
      'prsOnly'
    ])
  },
  components: {
    PopUp,
    Navbar,
    Sidebar,
    MessageModal,
    WarningModal,
    BudgetPercentageModal,
    PRModal,
    ConfirmModal,
    LoadingModal,
    SignatureModal,
    FeedbackModal,
  },
  setup () {
    return {
    }
  },
  name: 'create-memo',
  props: {
  },
  data: () => {
    return {
      attachments: null,
      prs: [],
      showPR: true,
      pendingChecked: false,
      claimOnly: false,
      subscription: null,
      isOk: true,
      message: '',
      messageTitle: '',
      startDate: '',
      endDate: '',
      title: '',
      objective: '',
      noOfParticipants: 1,
      notes: '',
      keyContacts: '',
      expandBody: false,
      dataLoaded: false,
      selectedBudgetSources: {},
      selectedActivityType: {},
      selectedActivityStakeholders: {},
      selectedSpecificObjective: {},
      selectedCurrency: {},
      selectedDestination: {},
      selectedAccommodation: {},
      selectedTransportation: {},
      selectedConference: {},
      selectedOffice: {},
      selectedRequestType: {},
      selectedBudgeted: {},
      selectedPlanned: {},
      showPercentageModal: false,
      feedback: null,
      feedbackTitle: 'Denial Feedback',
      saveMessage: process.env.VUE_APP_SAVE_MESSAGE,
      signatureLoaded: false,
      signatureData: null,
      destinations: [
        { id: 1, name: 'Maseru' },
        { id: 2, name: 'Local Outside Maseru' },
        { id: 3, name: 'Abroad / Outside Lesotho' }
      ],
      BASE_URL: process.env.VUE_APP_BASE_URL,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  unmounted () {
    // unmount the subscription
    if (this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  },
  mounted () {
    this.prs = this.prsOnly
    // this.getSignature()
    // get the prs
    this.getPrs()
  },
  methods: {
     downloadAttachments (originalFilename, generatedFilename) {
        this.$refs.loadingModal.openLoaderModal()
        const observable = ajax({
          method: 'GET',
          url: this.BASE_URL + '/pr/downloadAttachment?filename=' + generatedFilename,
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          responseType: 'blob'
        })

        const observer = {
          next: (response) => {
            const blob = response.response
            // const headers = response.responseHeaders
            console.log(response)
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', originalFilename || url.split('/').pop());
            document.body.appendChild(link);
            link.click();
            link.remove();
          },
          error: () => {
            // close the loader modal
            this.$refs.loadingModal.closeLoaderModal()
            // showing the dialog for the error
            this.isOk = false
            this.messageTitle = 'Error Message'
            this.message = 'Failed to download the attached files.'
            this.$refs.messageModal.openMessageModal()
          },
          complete: () => {
            this.$refs.loadingModal.closeLoaderModal()
          }
        }

        observable.subscribe(observer)
      },
       // file size converter
    fileSizeFormatter (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) {
        return '0 Bytes'
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
      // format the table data
      formatData (data) {
        var formattedData
        // check if it is a number
        if (data !== null && data !== undefined && !isNaN(data) && String(data).length > 2) {
          // format the number to a currency format
          var currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MWK' })
          formattedData = currencyFormat.format(String(data)).substring(4)
        } else if (data !== null && data !== undefined && data.toString().includes('-') && !isNaN(Date.parse(data))) {
          // check if the data is a date
          // formating the dates supplied
          var textDate = new Date(data)
          var formattedTextDate = textDate.getDate() + ' ' + this.months[textDate.getMonth()] + ' ' + textDate.getFullYear()
          formattedData = formattedTextDate
        } else {
          formattedData = data
        }
        return formattedData
      },
      // submit approval
      approval (status) {
        // has viwed all the details
        if (this.signatureData.length > 0) {
          // showing the loading modal
          this.$refs.loadingModal.openLoaderModal()

          const approverId = localStorage.getItem('approverId') 
          const prId = localStorage.getItem('prId')
          const observable = ajax({
            url: this.BASE_URL + '/pr-approval-trail/insert',
            method: 'POST',
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            body: {
              employee_id: approverId,
              status: status,
              pr_id: prId,
              feedback: this.feedback
            }
          })
          const observer = {
            next: () => {
              // go back to the previous page
              this.$router.push('/pending-pr')
            },
            error: () => {
              // close the loader modal
              this.$refs.loadingModal.closeLoaderModal()
              // showing the dialog for the error
              this.isOk = false
              this.messageTitle = 'Error Message'
              this.message = 'Failed to submit the pr approval.'
              this.$refs.messageModal.openMessageModal()
            },
            complete: () => {
              // closing the loading modal
              this.$refs.loadingModal.closeLoaderModal()
            }
          }

          observable.subscribe(observer)
        } else {
          this.$refs.signatureModal.openSignatureModal()
        } 
      },
    // show the denial modal
    showDenialModal () {
      this.isOk = false
      this.$refs.feedbackModal.openMessageModal()
    },
    // get the prs
    getPrs () {
        const requestId = localStorage.getItem('prId')
        // const approverId = localStorage.getItem('approverId')

        const observable = ajax({
          method: 'GET',
          url: this.BASE_URL + '/pr/findById?id=' + requestId,
          headers: {
            Authorization: `Bearer ${this.token}`
          },
        })
        const observer = {
          next: (response) => {
            const data = response.response[0]
            this.prs = data.prs.data
            this.attachments = data.attachment

            this.requestLoaded = true
          },
          error: () => {},
          complete: () => {}
        }

        observable.subscribe(observer)
      },
    // clear the pr vuex
    clearPrVuex () {
      this.$store.commit('mutateClearPRsOnly', [])
    },
    // submit the base64 signature
    submitSignature (base64) {
      // open the loading modal
      this.$refs.loadingModal.openLoaderModal()

      const observable = ajax({
        url: this.BASE_URL + '/signature/insert',
        method: 'POST',
        body: {
          employee_id: this.id,
          filename: base64
        },
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })

      const observer = {
        next: () => {
          this.$refs.loadingModal.closeLoaderModal()
          // showing the dialog for the error
          this.isOk = true
          this.messageTitle = 'Message'
          this.message = 'Successfully submitted your signature...'
          this.$refs.messageModal.openMessageModal()
        },
        error: () => {
          // close the loader modal
          this.$refs.loadingModal.closeLoaderModal()
          // showing the dialog for the error
          this.isOk = false
          this.messageTitle = 'Error Message'
          this.message = 'Failed to submit your signature, please try again later...'
          this.$refs.messageModal.openMessageModal()
        },
        complete: () => {
          this.$refs.loadingModal.closeLoaderModal()
          this.getSignature()
        }
      }

      observable.subscribe(observer)
    },
    // get the employee's signature
    getSignature () {
      const observable = ajax({
        url: this.BASE_URL + '/signature/findByEmployeeId?id=' + this.id,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })

      const observer = {
        next: (response) => {
          const data = response.response
          this.signatureData = data
          const size = data.length
          this.signatureLoaded = true

          if (size == 0) {
            this.$refs.signatureModal.openSignatureModal()
          }

          // 
        },
        error: () => {},
        complete: () => {}
      }
      
      observable.subscribe(observer)
    },
    // conf packages output
    confPackagesHtml (data) {
      var html = ''
      if (data.confPackage) {
        const packag = '<li>- CP1</li>'
        html += packag
      }

      if (data.confPackage2) {
        const packag = '<li>- CP2</li>'
        html += packag
      }

      if (data.confPackage3) {
        const packag = '<li>- CP3</li>'
        html += packag
      }

      if (data.confPackage4) {
        const packag = '<li>- CP4</li>'
        html += packag
      }

      if (data.confPackage5) {
        const packag = '<li>- CP5</li>'
        html += packag
      }

      if (data.hallHire) {
        const packag = '<li>- HallHire</li>'
        html += packag
      }
     
      return html
    },
    // refresh the prs
    refreshPRs () {
      this.prs = this.prsOnly
    },
    // delete all the PRs
    deleteAll () {
      this.prs = []
      this.$store.commit('mutateClearPRsOnly', [])
    },
    // open the confirm modal
    openConfirmModal () {
      this.$refs.confirmModal.openMessageModal()
    },
    // clears the data from the request
    clearRequest () {
      this.$store.commit('mutateMemo', null)
      this.$store.commit('mutateMoHBudget', null)
      this.$store.commit('mutateEgpafBudget', null)
      this.$store.commit('mutateEgpafIntlBudget', null)
      this.$store.commit('mutateUnitBudget', null)
      this.$store.commit('mutateSchedule', null)
      this.$store.commit('mutateUploadedFiles', [])
      window.location.reload()
    },
    budgetPercentageCheck () {
        try {
        if (Array.isArray(this.selectedBudgetSources)) {
          const size = this.selectedBudgetSources.length
          var total = 0
          for (let i = 0; i < size; i++) {
            const data = this.selectedBudgetSources[i]
            const percent = data.percentage

            if (percent === undefined || percent === null) {
              return false
            } else {
              total += parseFloat(percent)
            }
          }
        }
        // const siz\e
        total = parseInt(total)
        if (total !== 100) {
          return false
        } else {
          return true
        }
      } catch (error) {
        console.log(error)
        return false
      }
    },
    isPRFilled () {
      //  check if the accommodation details are filled
      if (this.selectedAccommodation.name === 'Yes' && this.selectedConference.name === 'No') {
        if (this.pr !== null && this.pr !== undefined && this.pr.budgetLine !== undefined && this.pr.budgetAmount !== undefined && this.pr.districtName.id !== undefined
            && this.pr.area !== undefined && this.pr.specification !== undefined && this.pr.checkInDate !== undefined
            && this.pr.checkOutDate !== undefined && this.pr.singleRooms !== undefined && this.pr.doubleRooms !== undefined && this.pr.deliveryDate !== undefined

            && this.pr.budgetLine !== '' && this.pr.budgetAmount !== '' && this.pr.districtName.id !== ''
            && this.pr.area !== '' && this.pr.specification !== '' && this.pr.checkInDate !== ''
            && this.pr.checkOutDate !== '' && this.pr.singleRooms !== '' && this.pr.doubleRooms !== '' && this.pr.deliveryDate !== ''
          ) {
            return true
        } else {
          return false
        }
      }
      // check if the conference details are filled
      else if (this.selectedAccommodation.name === 'No' && this.selectedConference.name === 'Yes') {
        if (this.pr !== null && this.pr !== undefined && this.pr.budgetLine !== undefined && this.pr.budgetAmount !== undefined && this.pr.districtName.id !== undefined
            && this.pr.area !== undefined && this.pr.specification !== undefined && this.pr.confPackage !== undefined
            && this.pr.Qparticipants !== undefined && this.pr.noParticipants !== undefined && this.pr.days !== undefined && this.pr.deliveryTime !== undefined && this.pr.deliveryDate !== undefined

            && this.pr.budgetLine !== '' && this.pr.budgetAmount !== '' && this.pr.districtName.id !== ''
            && this.pr.area !== '' && this.pr.specification !== '' && (this.pr.confPackage !== '' || this.pr.confPackage2 !== '' || this.pr.confPackage3 !== '' || this.pr.confPackage4 !== '' || this.pr.confPackage5 !== '' || this.pr.hallHire !== '')
            && this.pr.Qparticipants !== '' && this.pr.noParticipants !== '' && this.pr.days !== '' && this.pr.deliveryTime !== '' && this.pr.deliveryDate !== ''
          ) {
            return true
        } else {
          return false
        }
      }
      // else if the person has booked both
      else {
        if (this.pr !== null && this.pr !== undefined && this.pr.budgetLine !== undefined && this.pr.budgetAmount !== undefined && this.pr.districtName.id !== undefined
            && this.pr.area !== undefined && this.pr.specification !== undefined && this.pr.confPackage !== undefined
            && this.pr.Qparticipants !== undefined && this.pr.noParticipants !== undefined && this.pr.days !== undefined && this.pr.deliveryTime !== undefined && this.pr.deliveryDate !== undefined
            && this.pr.checkInDate !== undefined && this.pr.checkOutDate !== undefined && this.pr.singleRooms !== undefined && this.pr.doubleRooms !== undefined

            && this.pr.budgetLine !== '' && this.pr.budgetAmount !== '' && this.pr.districtName.id !== ''
            && this.pr.area !== '' && this.pr.specification !== '' && (this.pr.confPackage !== '' || this.pr.confPackage2 !== '' || this.pr.confPackage3 !== '' || this.pr.confPackage4 !== '' || this.pr.confPackage5 !== '' || this.pr.hallHire !== '')
            && this.pr.Qparticipants !== '' && this.pr.noParticipants !== '' && this.pr.days !== '' && this.pr.deliveryTime !== '' && this.pr.deliveryDate !== ''
            && this.pr.checkInDate !== ''
            && this.pr.checkOutDate !== '' && this.pr.singleRooms !== '' && this.pr.doubleRooms !== '' 
          ) {
            return true
        } else {
          return false
        }
        
      }
    },
    createPR () {
      this.$refs.prModal.setEditIndex(-1)
      this.$refs.prModal.openPRModal()  
    },
    editPR (index) {
      this.$refs.prModal.setEditIndex(index)
      this.$refs.prModal.openPRModal()  
    },
    deletePR (index) {
      this.prs.splice(index, 1)
      this.$store.commit('mutateDeleteIndexPRsOnly', index)
    },
    viewPercentages () {
      this.showPercentageModal = true
      setTimeout(() => {
        this.$refs.budgetPercentageModal.openMessageModal()      
      }, 200)
    },
    // save the percentage details
    savePercentageData (data) {
      this.showPercentageModal = false
      this.selectedBudgetSources = data
    },
    // shows a percentage error message
    percentageError(message) {
      this.showPercentageModal = false
      this.isOk = false
      this.messageTitle = 'Error Message'
      this.message = message
      this.$refs.messageModal.openMessageModal()
      console.log('error')
    },
    // pending requests check
    pendingRequestCheck () {
      const observable = ajax({
        url: this.BASE_URL + '/request/findUnliquidated?employeeId=' + this.id,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      
      const observer = {
        next: (response) => {
          const data = response.response
          const size = data.length
          if (size > 0) {
            // this.$refs.warningModal.openMessageModal()
            this.claimOnly = true
            this.pendingChecked = true
          }
        },
        error: () => {},
        complete: () => {}
      }

      observable.subscribe(observer)
    },
    warningHandler (event) {
      // move the user to the home page
      if (event.toString() === 'close') {
        this.$router.push('/employee-home')
      }
    },
    autosave() {
      this.$refs.popupRef.show()
      const observable = interval(1000 * 2) // Emit every second
      const observer = {
        next: () => {
          const dataToSave = {
            title: this.title,
            budgetSource: this.selectedBudgetSources,
            requestType: this.selectedRequestType,
            activityType: this.selectedActivityType,
            stakeholders: this.selectedActivityStakeholders,
            specificObjectives: this.selectedSpecificObjective,
            currency: this.selectedCurrency,
            accommodation: this.selectedAccommodation,
            transportation: this.selectedTransportation,
            conferencing: this.selectedConference,
            budgeted: this.selectedBudgeted,
            planned: this.selectedPlanned,
            expectedParticipants: this.participants,
            notes: this.notes,
            destination: this.selectedDestination
          }
          this.$store.commit('mutateMemo', dataToSave)
          // console.log('saving')
        },
        error: () => {}
      }
      this.subscription = observable.subscribe(observer)
    },
    openMessageModal () {
      this.isOk = false
      this.messageTitle = 'Error Message'
      this.message = 'Fill all the fields in the memo to move to the next step...'
      this.$refs.messageModal.openMessageModal()
    },
    // load the stoemerald memo data
    loadMemoData () {
      if (this.memo !== null) {
        this.title = this.memo.title
        this.participants = this.memo.expectedParticipants
        this.notes = this.memo.notes
        this.selectedBudgetSources = this.memo.budgetSource
        this.selectedRequestType = this.memo.requestType
        this.selectedActivityType = this.memo.activityType
        this.selectedActivityStakeholders = this.memo.stakeholders
        this.selectedSpecificObjective = this.memo.specificObjectives
        this.selectedCurrency = this.memo.currency
        this.selectedAccommodation = this.memo.accommodation
        this.selectedTransportation = this.memo.transportation
        this.selectedConference = this.memo.conferencing
        this.selectedPlanned = this.memo.planned
        this.selectedBudgeted = this.memo.budgeted
        
        if (this.memo.destination.id !== undefined && this.memo.destination.id !== null) {
          this.selectedDestination = this.memo.destination
        }
        
        this.dataLoaded = true
      } else {
        this.dataLoaded = true
      }
    },
    next () {
      // moving to the next step if the pr data has detaisl
      if (Array.isArray(this.prs) && this.prs.length > 0) {
        this.$router.push('pr-summary')
      } else {
        // showing the dialog for the error
        this.isOk = true
        this.messageTitle = 'Message'
        this.message = 'Create a PR to move to the next step.'
        this.$refs.messageModal.openMessageModal()
      }
    },
    back () {
      this.$router.push('create-pr')
    },
    // expands or collapses the main body
    expand (value) {
      this.expandBody = value
    }
  }
}
</script>

<style>

#chart-container {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  height: 40vh;
}

</style>
